import React from 'react';

const ConfirmationModal = ({title,message,closeModal,successAction,modalData}) => {
    return (
        <div>
            <input type="checkbox" id="my-modal-6" className="modal-toggle" />
            <div className="modal modal-bottom sm:modal-middle">
                <div className="modal-box">
                    <h3 className="font-bold text-lg text-red-600">{title}!</h3>
                    <p className="py-4">{message}!</p>
                    <div className="modal-action">
                        <label onClick={()=> successAction(modalData)} htmlFor="my-modal-6" className="btn">Confirm</label>
                        <button onClick={closeModal} className='btn'>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;